import modalHTml from './confirm-modal/confirm.modal.html';
import modalControl from './confirm-modal/confirm.modal';

export default class CommandsDashboardService {
  constructor($uibModal, CommandsRepo) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.commandsapiRepo = CommandsRepo;

    this.supportedPackagesCommandsMap = {
      '2042281683352289994': ['start_stop', 'throttle'],
      '2395104989652451496': ['dse_start_stop', 'dse_throttle']
    };
  }

  /**
   *
   * @param {*} assetPackages
   * @returns commands list
   */
  getpackageSupportedCommands(assetPackages = []) {
    const packageId = Object.keys(this.supportedPackagesCommandsMap).find((k) =>
      (assetPackages || []).includes(k),
    );
    return packageId ? this.supportedPackagesCommandsMap[packageId] : [];
  }

  getSupportedCommands(equipment, assetPackages) {
    const assetcommandsList = equipment?.relationships?.deviceCommands?.data || [];
    this.packagesCommands = this.getpackageSupportedCommands(assetPackages);

    const supCommands = assetcommandsList
      .filter((c) => this.packagesCommands.includes(c.id))
      .reduce(
        (acc, c) => ({
          ...acc,
          [c.id]: {
            key: c.id,
            parameters: c.attributes.parameters,
            uiParam: c.attributes.parameters.find((p) => p.name === 'write-values' || p.name === 'value'),
          },
        }),
        {},
      );
    return { commands: supCommands, total: Object.keys(supCommands).length };
  }

  sendCommand(assetId, command, userInput) {
    const { key, parameters = [] } = command;
    const bodyParams = {};
    parameters.forEach((parameter) => {
      bodyParams[parameter.name] = `${parameter.value}`;
    });
    
    if (bodyParams['write-values'] === "") {      
      bodyParams['write-values'] = `${userInput}`;
    } else {
      bodyParams['value'] = `${userInput}`;
    }    

    return this.commandsapiRepo.executeCommand(assetId, key, bodyParams);
  }

  confirm(command, option) {
    return this.$uibModal.open({
      animation: true,
      size: 'sm',
      template: modalHTml,
      controller: modalControl,
      controllerAs: 'modalVm',
      windowClass: 'd-com-modal',
      resolve: {
        data: () => ({ command, option }),
      },
    }).result;
  }

  //*** commmands ***//
  commandStatusMap() {
    return {
      pending: 'Initiated',
      aborted: 'Not Acknowledged',
      completed: 'Completed',
      rejected: 'Failed',
      acknowledged: 'Processing',
      pendingAbort: 'Not Acknowledged',
    };
  }

  /**
   *
   * @param {*} assetId
   * @returns command feedback and history status filtered to dashboard supported commands only.
   */
  getAssetCommandsHistroy(assetId) {
    return this.commandsapiRepo
      .getEquipmentCommandHistory(assetId)
      .then((response = {}) =>
        (response.data || []).filter((history) => this.packagesCommands.includes(history.name)),
      );
  }
}
